// extracted by mini-css-extract-plugin
export default {"fallback":"ifPJ2HaRxRLXgUJyFS0O"};